import { __extends } from "tslib";
import { StartTextDetectionRequest, StartTextDetectionResponse } from "../models/index";
import { deserializeAws_json1_1StartTextDetectionCommand, serializeAws_json1_1StartTextDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartTextDetectionCommand = /** @class */ (function (_super) {
    __extends(StartTextDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartTextDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartTextDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartTextDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartTextDetectionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartTextDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartTextDetectionCommand(input, context);
    };
    StartTextDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartTextDetectionCommand(output, context);
    };
    return StartTextDetectionCommand;
}($Command));
export { StartTextDetectionCommand };
//# sourceMappingURL=StartTextDetectionCommand.js.map